<template lang='pug'>
  transition(name='fade')
    aside.c-off-canvas__wrapper(@click.self="$emit('hide')")
      .c-off-canvas.u-overflow-auto
        button.u-bg-transparent.u-border-none.u-mb3.u-pl0(@click="$emit('hide')")
          i.u-icon.u-color-primary.u-fz-h3 close
        ul.u-list-none.u-pl0.u-mb4.u-mt2
          li
            router-link.c-off-canvas__menu-item(:to="{ name: 'About'}")
              span La radio
              i.u-icon arrow_extend_right
          li
            router-link.c-off-canvas__menu-item(:to="{ name: 'Programs'}")
              span Programación
              i.u-icon arrow_extend_right
          li
            router-link.c-off-canvas__menu-item(:to="{ name: 'Contact'}")
              span Contacto
              i.u-icon arrow_extend_right
          li
            router-link.c-off-canvas__menu-item(:to="{ name: 'Search'}")
              span Buscar
              i.u-icon arrow_extend_right
        ul.u-list-none.u-pl0.u-mb4
          li.c-off-canvas__category(v-for='category in categories', :class="selectedCategory === category.id ? 'is-active' : ''", @click="$emit('hide')")
            router-link.u-flex.u-items-center.u-white(:to="{ name: 'SearchCategory', params: {slug: category.slug}}")
              i.u-icon.u-mr2 circle
              span() {{ category.name }}
        p.u-mb2
          i.u-icon.u-white
            | location
          span.u-white.u-uppercase.u-fw-s-bold Dirección
        p.u-color-text.u-fz-h6.u-mt0
          | {{ company.address }}
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      isShowMenu: Boolean
    },

    computed: {
      ...mapGetters({
        categories: 'categories',
        selectedCategory: 'selectedCategory',
        company: 'company'
      })
    },

    beforeCreate () {
      window.$('body').css('overflow-y', 'hidden')
    },

    beforeDestroy () {
      window.$('body').css('overflow-y', '')
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/shared/components/AppOffHeader.vue